import {ACTIVE_TASK_STATE} from "~/states/state";
import type {JsonDataResponse} from "~/types/types";

export default defineNuxtRouteMiddleware(async (to, from) => {
    const {options} = useFetchHelper()

    const res = await $fetch<JsonDataResponse<number>>(`/api/active-task`, options())

    const activeTasks = useState<number>(ACTIVE_TASK_STATE)

    if (res.status) {
        activeTasks.value = res.data
    }
})
